import { render, staticRenderFns } from "./EditAdvertisementModal.vue?vue&type=template&id=38340138&scoped=true&"
import script from "./EditAdvertisementModal.vue?vue&type=script&lang=js&"
export * from "./EditAdvertisementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38340138",
  null
  
)

export default component.exports